import React, { useState, useEffect } from 'react'
import './datasetrecipes.css'
import tabler from './nlp/tabler_adl.js';

import frm from './formAux'
import $ from 'jquery';
import Button from 'react-bootstrap/Button'

let global = null;
let datasetId = null;
let datasetData = null;
let config = {};
let configBase = {};
let recipes = null;
let closeTid = null;
let origModel = null;
let history = null;
let paramsGet = null;
let params = {};
let bptid = null;

function clone(o) { return JSON.parse(JSON.stringify(o)); }

let selectedRecipes = [];
let selectedItems = [];

const DatasetRecipes = () => {
	if( paramsGet === null ) paramsGet = params = window.getParams() || {};
	var tabs = ['classification', 'summarization', 'redaction', 'Q&A'];

	const [show, setShow] = useState('');
	const [models, setModels] = useState(null);

	let current = null;

	const onChange = async (val) => {
		console.log( 'configBase', configBase );
		console.log( 'configOrig', JSON.stringify(config) );
		if( configBase && JSON.stringify(config) != configBase ) {
			let confirm = await frm.myConfirm('Recipe not saved', 'There are unsaved changes for the current recipe. Do you really want to change recipe tab?');
			if( !confirm ) return;
		}
		setShow(val);
		console.log( 'MODELS', models )
		let elem = document.getElementsByClassName(val);
		console.log('elem', elem)
	};

	function buttons(){
		$('#savebutton').off('click').on('click', saveRecipe )
		$('#historybutton').off('click').on('click', () => {
			history = !history;
			setHistory( history );
			if( history ) {
				showHistory(show);
			}
		})
		$('#setbutton').off('click').on('click', () => {
			setDefaultPrompt( selectedRecipes[0] )
		})
		$('#comparebutton').off('click').on('click', () => {
			viewPrompts( selectedRecipes )
		})
		$('#backbutton').off('click').on('click', () => {
			setHistory( 1 )
			showHistory();
		})
		$('.recipe-buttons').show();

	}
	window.setShow = setShow;

	async function setDefaultPrompt( recipeId ) {
		datasetData.currentRecipes[show] = recipeId;
		await window.post( 'set_current_recipe', {datasetId:datasetData.datasetId, recipeId:recipeId} )
		setHistory( false )
		drawForm(show);
	}

	async function viewPrompts( prompts ) {
		$('#itembutton').off('click').on('click', actionPopup );


		function doAction( type ) {
			// compatibility vars
			let gDataset = global.currentDataset;
			let targetObj = gDataset;
			let targetIds = selectedItems;
			let groundtruthProject = false;
			let project = null;
			let dataset = gDataset;
			let descriptor = dataset.descriptor;
			function draw() {}
			function mkAnnotationData() {}
			function mkFilterData() {}
			function setFilters() {}
			function refreshItems() {}
			var targetLabel = selectedItems.length == 1 ? ' item' : ' items';
		}

		function actionPopup(ev) {
			let sSelected = ' ('+selectedItems.length+')';
			var mpos = $('.maincontent').position();
			var pos = $('#itembutton').parent().position();
		
			console.log( 'mpos', mpos, 'pos', pos )
			if( mpos.top == 0 ) mpos.top = 20;
			var top = mpos.top + pos.top + $('#itembutton').outerHeight() + 10;

			var left = mpos.left + pos.left + parseInt($('.maincontent').css('marginLeft'))+7;
			var width = 400;
			var actionPanel = $('<DIV>').addClass('user-panel').css({ top: top, left: left, wwidth: width });
		
			actionPanel.append($('<DIV>').html('<i class="fa fa-tag"></i> Add tag' + sSelected).on('click', function () { doAction('addtag') }));
			actionPanel.append($('<DIV>').html('<i class="fa fa-close"></i> Remove tags' + sSelected).on('click', function () { doAction('deltag') }));
			setTimeout(function () {
				$(document.body).on('click', hideAction);
				$(document.body).append(actionPanel);
				// var left = mpos.left + $('.maincontent').width() + parseInt($('.maincontent').css('marginLeft')) - actionPanel.width();
				actionPanel.css({ left: left })
				var dleft = actionPanel.width() + left - $(window).width() + 50;
				// console.log( 'DLEFT', left, actionPanel.width(), $(window).width(), '=', dleft )
				if (dleft > 0) actionPanel.css({ left: left - dleft })
				function hideAction() {
					actionPanel.remove();
					$(document.body).off('mousedown');
				}
				// console.log('actionPopup', top, left)
			}, 100);
		}
		
		console.log( 'viewPrompts', prompts )
		$('.topbtn').hide();
		$('#backbutton').show()
		$('#exportbutton').show().off('click').on('click', async () => {
			let url = window.postURL('view_recipes',{recipeIds:prompts, export: true})

			let getData = [];
			let pdata = window.postParams({recipeIds:prompts, export: true});
			for (var k in pdata) getData.push(k + '=' + escape(pdata[k]));
			console.log( url + '/?' + getData.join('&') )
			document.location.replace( url + '/?' + getData.join('&') );
		});

		let {data} = await window.post('view_recipes',{recipeIds:prompts})
		console.log( 'DATA', data )
		$('.historytab').html('<Table id="documentlist" bordered hover size="sm" className="table-grid mt-3"></Table>')
		let twidth = 80/(1+data.recipes.length);
		let title = data.recipes.length == 1 ? 'Prompt Result' : 'Prompt Comparsion'
		var desc = {
			title: title,
			columns: {
				itemId: 'Item',
				source: 'Source',
				text: 'Item Text',
			},
			filter: true,
			search: true,
			sort: true,
			initialSort: 'modified',
			initialSortDir: -1,
			pageSize: 10,
			noFilter: {
				modified:1,
			},
			noSort: null,
			// centerCol: ['modified'],
			format: tabler.formatString,
			forceType: {
				// numProjects:1,
				// items:1,
				// modified: 1,
			},
			colWidth: {
				source: 10,
				itemId: 10,
				text: twidth,
				// promptText: 20,
				// classList: 20,
			},
			formatCol:{
				// modified: tabler.formatTimeAgoSec,
				// runTs: tabler.formatTimeAgoSec,
				text: frm.smallerText,
			},
			maxLinesCol: {
				text: 4,
			},
			selectMode: true,
			selectId: 'itemId',
			// clickCol: ['stateLabel','source'],
		}
		for( let r of data.recipes ) {
			desc.columns[r.recipeId] = r.recipeName;
			desc.formatCol[r.recipeId] = frm.smallerText;
			desc.colWidth[r.recipeId] = twidth;
			desc.maxLinesCol[r.recipeId] = 4;
		}
		let tab = tabler.table($('#documentlist'), desc, datasetId+data.recipes.join('.') );
		tab.onSelect( function(o){
			selectedItems = Object.keys(o);
			if( selectedItems.length ) {
				$('#itembutton').show().html('Item actions (' + selectedItems.length + ')');
			}
			else $('#itembutton').hide();
			console.log( 'selectedItems', selectedItems )
			// setHistory( history )
		})
		for( let r of data.records ) {
			for( let s of r.results ) {
				r[s.recipeId] = s.result === null ? '-' : s.result;
			}
			tab.addRow(r, async function (col, row) {
				console.log('tabler clickkkkk', col, row, row[col])
			})
		}
		tab.draw();
	}

	async function viewQA( recipeId ) {
		console.log( 'viewQA', recipeId )
		$('.topbtn').hide();
		$('#backbutton').show()
		$('#exportbutton').show().off('click').on('click', async () => {
			// alert(1)
			let url = window.postURL('list_recipe_prompt_feedback', { recipeId: recipeId })
			document.location.replace(url + '/?recipeId=' + recipeId)
			// frm.myAlert('Download', 'Download promt chatbot user feedback?', 'Download User Feedback', async () => {
			// }, 'Cancel')
		});

		let {data} = await window.post('list_recipe_qa',{recipeId:recipeId})
		console.log( 'DATA', data )
		$('.historytab').html('<Table id="documentlist" bordered hover size="sm" className="table-grid mt-3"></Table>')
		// let twidth = 80/(1+data.recipes.length);
		let twidth = 200;
		let title = 'Chatbot Queries'
		var desc = {
			title: title,
			columns: {
				prompt: 'Question',
				answer: 'Response',
				sourcesCount: 'Sources',
				userId: 'User',
				ts: 'Date',
			},
			filter: true,
			search: true,
			sort: true,
			initialSort: 'modified',
			initialSortDir: -1,
			pageSize: 10,
			noFilter: {
				modified:1,
			},
			noSort: null,
			// centerCol: ['modified'],
			format: tabler.formatString,
			forceType: {
				// numProjects:1,
				// items:1,
				// modified: 1,
			},
			colWidth: {
				source: 10,
				itemId: 10,
				text: twidth,
				// promptText: 20,
				// classList: 20,
			},
			formatCol:{
				// modified: tabler.formatTimeAgoSec,
				ts: tabler.formatTimeAgoSec,
				// text: frm.smallerText,
			},
			maxLinesCol: {
				text: 4,
			},
			selectMode: false,
			selectId: 'promptId',
			// clickCol: ['stateLabel','source'],
		}
		let tab = tabler.table($('#documentlist'), desc, datasetId+recipeId );
		tab.onSelect( function(o){
			selectedItems = Object.keys(o);
			if( selectedItems.length ) {
				$('#itembutton').show().html('Item actions (' + selectedItems.length + ')');
			}
			else $('#itembutton').hide();
			console.log( 'selectedItems', selectedItems )
			// setHistory( history )
		})
		for( let r of data.records ) {
			r.sourcesCount = (r.source || []).length;
			if( r.error ) r.answer = '<span class="prompt-error">Error: '+r.error+'</span>';
			tab.addRow(r, async function (col, row) {
				console.log('tabler clickkkkk', col, row, row[col])
			})
		}
		tab.draw();
	}



	function showHistory() {
		console.log( 'showHistory')
		$('.historytab').html('<Table id="documentlist" bordered hover size="sm" className="table-grid mt-3"></Table>')
		console.log( recipes );
	
		var desc = {
			title: 'Prompt History',
			columns: {
				recipeName2: 'Name',
				promptText: 'Prompt',
				redactList: 'Redact',
				classList: 'Classes',
				recipeType: 'Type',
				modified: 'Modified',
				runs: 'Runs',
				runTs: 'Last Run',
			},
			filter: true,
			search: true,
			sort: true,
			initialSort: 'modified',
			initialSortDir: -1,
			pageSize: 10,
			noFilter: {
				modified:1,
			},
			noSort: null,
			centerCol: ['modified'],
			format: tabler.formatString,
			forceType: {
				numProjects:1,
				items:1,
				modified: 1,
			},
			colWidth: {
				recipeName: 15,
				promptText: 20,
				classList: 20,
			},
			formatCol:{
				modified: tabler.formatTimeAgoSec,
				runTs: tabler.formatTimeAgoSec,
				promptText: frm.smallerText,
				classList: frm.smallerText,
				redactList: frm.smallerText,
			},
			maxLinesCol: {
				promptText: 4,
				tags: 4,
			},
			selectMode: true,
			selectId: 'recipeId',
			// clickCol: ['stateLabel','source'],
		}
		if( show != 'classification' ) delete desc.columns.classList;
		if( show != 'redaction' ) delete desc.columns.redactList;
		else delete desc.columns.promptText;
		
		if( config.recipeType == 'Q&A' ) {
			desc.columns.runs = 'Queries';
			desc.columns.runTs = 'Last Qry.';
		}
		console.log( 'DESC', desc )
		let tab = tabler.table($('#documentlist'), desc, datasetId+show );
		tab.onSelect( function(o){
			console.log( 'select', o )
			selectedRecipes = Object.keys(o);
			setHistory( history )
		})
		let current = datasetData.currentRecipes[show];
		for (let r of recipes) {
			if (r.recipeType != show) continue;
			if( r.classes ) {
				r.classList = r.classes.map( v => v.name );
				if( r.defaultClass ) r.classList.push( r.defaultClass );
				r.classList = r.classList.join(', ')
			}
			if( r.redact ) {
				r.redactList = [];
				for( let k in r.redact ) if( r.redact[k] ) r.redactList.push( k );
				r.redactList = r.redactList.join(', ')
			}
			console.log('rrrr', r.recipeType, show)
			if (!r.modified) r.modified = r.created;
			if( !r.runTs ) r.runTs = 0;
			r.isCurrent = current == r.recipeId ? 'Default' : '';
			r.recipeName2 = r.recipeName;

			if( r.isCurrent ) r.recipeName2 = '<b>' + r.recipeName2 + ' (Default)</b>'

			console.log( 'addRow', r )

			tab.addRow(r, async function (col, row) {
				console.log('tabler clickkkkk', col, row, row[col])
				config = clone(row);
				delete config._id;
				if( row.recipeType == 'Q&A') {
					// frm.myAlert('Download', 'Download promt chatbot user feedback?', 'Download User Feedback', async () => {
					// 	let url = window.postURL('list_recipe_prompt_feedback', {recipeId:row.recipeId})
					// 	document.location.replace( url+'/?recipeId='+row.recipeId )
					// }, 'Cancel' )
					viewQA( row.recipeId)
					return;
				}
				if( !row.runs ) return;
				viewPrompts( [row.recipeId] )
			})
		}
		tab.draw();
	}


	function setHistory( h ) {
		history = h;
		$('#historybutton').html( history ? 'Show current prompt' : 'Prompt History')
		$('.topbtn').hide();
		console.log( 'selectedRecipes', selectedRecipes )
		$('#itembutton').hide();
		if( history ) {
			$('.recipetab').hide();
			$('#historybutton').show();
			if( selectedRecipes.length == 1 ) $('#setbutton').show();
			else if( selectedRecipes.length > 1 ) $('#comparebutton').show();
		} 
		else {
			$('.historytab').html('');
			$('#historybutton').show();
			$('.recipetab').show();
			$('#savebutton').show();
		}
	}

	function getCurrent() {
		buttons();
		current = datasetData && datasetData.currentRecipes && datasetData.currentRecipes[show] || null;
		console.log('current', current)
		if (current && recipes && recipes.length) {
			let recipe = recipes.find(r => r.recipeId == current);
			config = clone(recipe)
			delete config._id;
			origModel = config.modelId;
			setHistory( true );
			showHistory();
		}
		else {
			config = {
				recipeId: null,
				datasetId: datasetId,
				recipeType: show,
				modelId: null,
			};
			origModel = null;
			setHistory( false )
		}
		window.config = config;
		configBase = null;
	}

	function saveConfigBase() {
		setTimeout( function(){
			if( !configBase ) configBase = JSON.stringify(config)
		}, 500 );
	}

	function drawForm( s ) {
		switch (s) {
			case 'redaction':
				redactionCofig();
				break;

			case 'classification':
				classifConfig();
				break;

			case 'summarization':
				summConfig();
				break;

			case 'Q&A':
				qnaConfig();
				break;

			default:
				break;
		}
	}
	

	async function saveRecipe(){
		let ckfields = ['modelId'];
		if( config.recipeType == 'Q&A') ckfields.push('fallbackModelId')
		frm.removeInlineErrors();
		let errors = false;
		for( let c of ckfields ) {
			if( !config[c] ) {
				frm.inlineError($('#op'+c), 'information required')
				errors = true;
			}
		}
		if( errors ) return;
		frm.loading('saving');
		let {data} = await window.post('save_recipe', config );
		frm.loadingOut('');
		if( !data.status ) return frm.myAlert( 'Save error', data.value );
		console.log( 'save', show, config, data )
		closeTid = setTimeout( () => frm.myAlertClose(),3000)
		frm.myAlert('Saved', data.value, 'Ok', () => clearTimeout(closeTid) );
		if( !datasetData.currentRecipes )datasetData.currentRecipes = {}
		datasetData.currentRecipes[config.recipeType] = config.recipeId = data.recipeId;
		window.datasetData = datasetData;
		global.currentDataset = datasetData;
		window.saveSession();
		let rfind = recipes.find( r => r.recipeId == data.recipeId )
		if( !rfind ) {
			config.modified = data.modified;
			config.created = data.created;
			delete config.runs;
			delete config.runTs;
			recipes.push( config );
		}
		else {
			rfind.recipeId = data.recipeId;
			rfind.modified = data.modified;
		}
		configBase = null;
		setShow( show );
	}

	async function testRecipe() {
		frm.loading('Generating Response');
		let {data} = await window.post('test_recipe', config );
		frm.loadingOut('');
		console.log( 'TEST', data );
		let output = ''
		if( typeof(data) == 'string' ) output = data.trim();
		else output = '<pre>'+JSON.stringify(data,null,'    ')+'</pre>';
		frm.myAlert('Recipe Test Output', output, 'Ok');
        $('.modal-dialog').css({maxWidth: 1024})
	}

	const redactionCofig = () => {
		console.log('hix')
		getCurrent();
		let typeField = frm.configSection($('.recipes_panel_one'), 'Model Info', true);

		let fallbackModels = [];
		let selectedModel = {};
		let optionsList = [];

		models.map((model) => {
			if (model.type === 'pii_redaction') {
				optionsList.push({ value: model.id, label: model.name })
			}
			else if (model.type === 'fallback_llm') {
				fallbackModels.push({ value: model.id, label: model.name })
			}
		});


		let configOne = [
			{
				"title": "Primary Model",
				"key": "modelId",
				"type": "dropdown",
				"placeholder": "Select model",
				"options": optionsList,
				"callback": function (v, o) {
					console.log('OPTION CALLBACK', v, 'o', o, models )
					selectedModel = models.find(m => m.id == v);
					if( !selectedModel ) return;
					console.log( 'selectedModel', selectedModel )
					if( v != origModel ) {
						origModel = v;
						let copy = ['promptText', 'testText'];
						for (let c of copy) {
							console.log( 'copy', c, selectedModel.llm )
							config[c] = selectedModel.llm[c];
						}
					}
					restConfig();
				},
				"containerClass": "prompt-inline",
			},

		]
		frm.configOptions(typeField, configOne, config);

		function restConfig() {
			let promptField = frm.configSection($('.recipes_panel_one'), 'Redaction options', true);

			let redact = {
				'Financial': [
					'BANK_ACCOUNT_NUMBER',
					'BANK_ROUTING',
					'CREDIT_DEBIT_NUMBER',
					'CREDIT_DEBIT_CVV',
					'CREDIT_DEBIT_EXPIRY',
					'PIN',
				],
				'Personal': [
					'NAME',
					'ADDRESS',
					'PHONE',
					'EMAIL',
					'AGE',
				],
				'Technical Security': [
					'USERNAME',
					'PASSWORD',
					'URL',
					'AWS_ACCESS_KEY',
					'AWS_SECRET_KEY',
					'IP_ADDRESS',
					'MAC_ADDRESS',
				],
				'National': [
					'SSN',
					'PASSWORD_NUMBER',
					'DRIVER_ID',
				],
				'Other': [
					'DATE_TIME',
				]
			}

			let configTwo = [];

			configTwo.push(
				{
					"key": "recipeName",
					"title": "Prompt Name",
					"label": "prompt name",
					"placeholder": "Enter prompt name",
					"default": selectedModel.name,
					"type": "string"
				}
			)

			if (!selectedModel.llm.redact) selectedModel.llm.redact = {};

			for (let rtype in redact) {
				let title = rtype;
				for (let o of redact[rtype]) {
					configTwo.push(
						{
							"key": "redact." + o,
							"title": title,
							"label": o,
							"type": "boolean",
							"default": false,
							"css": { marginLeft: 50 }
						}
					)
					title = '';
				}
			}				

			frm.configOptions(promptField, configTwo, config);

			let configEnd = [
				{
					"title": "Item Processing",
					"label": "",
					"type": 'title',
				},				
				{
					"key": "enablePreProcess",
					"title": "",
					"label": "Run upon dataset items upload",
					"type": "boolean",
				},
				{
					"title": "Test Recipe",
					"label": "aaaa",
					"type": 'title',
				},				
				{
					"title": "",
					"key": "testText",
					"placeholder": "Insert the request payload",
					"default": selectedModel.llm.testText,
					"type": "textarea",
					"css": { height: 200 },
				},
				{
					"label": 'Test model',
					"type": 'button',
					"callback": testRecipe,
				}
			]

			frm.configOptions(promptField, configEnd, config);
			saveConfigBase()
		}
	}

	const classifConfig = () => {
		getCurrent();

		let typeField = frm.configSection($('.recipes_panel_one'), 'Model Info', true);

		let fallbackModels = [];
		let selectedModel = {};
		let optionsList = [];

		models.map((model) => {
			if (model.type === 'classification_prompt') {
				optionsList.push({ value: model.id, label: model.name })
			}
			else if (model.type === 'fallback_llm') {
				fallbackModels.push({ value: model.id, label: model.name })
			}
		});

		console.log('optxy', optionsList)

		let configOne = [
			{
				"title": "Primary Model",
				"key": "modelId",
				"type": "dropdown",
				"placeholder": "Select model",
				"options": optionsList,
				"callback": function (v, o) {
					// console.log('OPTION CALLBACK', v, 'o', o, models )
					selectedModel = models.find(m => m.id == v);
					if( !selectedModel ) return;
					console.log( 'selectedModel', selectedModel )
					if( v != origModel ) {
						origModel = v;
						let copy = ['promptText', 'testText'];
						for (let c of copy) {
							console.log( 'copy', c, selectedModel.llm )
							config[c] = selectedModel.llm[c];
						}
					}
					restConfig();
				},
				"containerClass": "prompt-inline",
			},
		]
		frm.configOptions(typeField, configOne, config);

		function restConfig() {
			let promptField = frm.configSection($('.recipes_panel_one'), 'Prompt Design', true);

			let configTwo = [];

			configTwo.push(
				{
					"key": "recipeName",
					"title": "Prompt Name",
					"label": "prompt name",
					"placeholder": "Enter prompt name",
					"default": selectedModel.name,
					"type": "string"
				}
			)
			configTwo.push(
				{
					"title": "Prompt Text",
					"key": "promptText",
					"placeholder": "Enter default prompt text",
					"default": selectedModel.llm.promptText,
					"type": "textarea",
					"css": { height: 200 },
				}
			)
			configTwo.push(
				{
					"title": "Temperature (0-1)",
					"key": "temperature",
					"placeholder": "enter temperature",
					"default": selectedModel.llm.temperature || 0,
					"type": "float",
					// "css": { height: 200 },
				}
			)
			console.log( 'CLASSES', JSON.stringify(config.classes) )
			let mclasses = {
                'name': { type: 'text', placeholder: 'Enter Class Name', fforceWidth: 300, label: '' },
            }
	
            configTwo.push(
                {
                    "title": "Classification Classes",
                    "key": "classes",
                    "fieldKey": 'name',
                    "defaultField": 'name',
                    "type": "gridlist",
                    "fields": mclasses,
                    "arrayOutput": true,
                }
            )
            configTwo.push(
                {
                    "title": "Default Class",
                    "key": "defaultClass",
                    "placeholder": "Enter default Class",
                    "type": "string"
                } 
            )


			frm.configOptions(promptField, configTwo, config);

			let configEnd = [
				{
					"title": "Item Processing",
					"label": "",
					"type": 'title',
				},				
				{
					"key": "enablePreProcess",
					"title": "",
					"label": "Run upon dataset items upload",
					"type": "boolean",
				},
				{
					"title": "Test Recipe",
					"label": "aaaa",
					"type": 'title',
				},				
				{
					"title": "",
					"key": "testText",
					"placeholder": "Insert the request payload",
					"default": selectedModel.llm.testText,
					"type": "textarea",
					"css": { height: 200 },
				},
				{
					"label": 'Test model',
					"type": 'button',
					"callback": testRecipe,
				}
			]

			frm.configOptions(promptField, configEnd, config);
			saveConfigBase()
		}
	}

	const summConfig = () => {
		getCurrent();

		let typeField = frm.configSection($('.recipes_panel_one'), 'Model Info', true);

		let fallbackModels = [];
		let selectedModel = {};
		let optionsList = [];

		models.map((model) => {
			if (model.type === 'summarization_prompt') {
				optionsList.push({ value: model.id, label: model.name })
			}
			else if (model.type === 'fallback_llm') {
				fallbackModels.push({ value: model.id, label: model.name })
			}
		});

		let configOne = [
			{
				"title": "Primary Model",
				"key": "modelId",
				"type": "dropdown",
				"placeholder": "Select model",
				"options": optionsList,
				"callback": function (v, o) {
					// console.log('OPTION CALLBACK', v, 'o', o, models )
					selectedModel = models.find(m => m.id == v);
					if( !selectedModel ) return;
					console.log( 'selectedModel', selectedModel )
					if( v != origModel ) {
						origModel = v;
						let copy = ['promptText', 'testText'];
						for (let c of copy) {
							console.log( 'copy', c, selectedModel.llm )
							config[c] = selectedModel.llm[c];
						}
					}
					restConfig();
				},
				"containerClass": "prompt-inline",
			},
		]

		frm.configOptions(typeField, configOne, config);

		function restConfig() {
			let promptField = frm.configSection($('.recipes_panel_one'), 'Prompt Design', true);

			let configTwo = [
				{
					"key": "recipeName",
					"title": "Prompt Name",
					"label": "prompt name",
					"placeholder": "Enter prompt name",
					"default": selectedModel.name,
					"type": "string"
				},
				{
					"title": "Prompt Text",
					"key": "promptText",
					"placeholder": "Enter default prompt text",
					"default": selectedModel.llm.promptText,
					"type": "textarea",
					"css": { height: 200 },
				},
				{
					"title": "Max Words",
					"key": "summaryMaxWords",
					"placeholder": "Enter number",
					"default": 20,
					"type": "int"
				},
				{
					"title": "Temperature (0-1)",
					"key": "temperature",
					"placeholder": "enter temperature",
					"default": selectedModel.llm.temperature || 0,
					"type": "float",
					// "css": { height: 200 },
				},
			]

			frm.configOptions(promptField, configTwo, config);

			let configEnd = [
				{
					"title": "Item Processing",
					"label": "",
					"type": 'title',
				},				
				{
					"key": "enablePreProcess",
					"title": "",
					"label": "Run upon dataset items upload",
					"type": "boolean",
				},
				{
					"title": "Test Recipe",
					"label": "aaaa",
					"type": 'title',
				},				
				{
					"title": "",
					"key": "testText",
					"placeholder": "Insert the request payload",
					"default": selectedModel.llm.testText,
					"type": "textarea",
					"css": { height: 200 },
				},
				{
					"label": 'Test Model',
					"type": 'button',
					"callback": testRecipe,
				}
			]

			frm.configOptions(promptField, configEnd, config);
			saveConfigBase()
		}

	}

	const qnaConfig = () => {
		getCurrent();

		let typeField = frm.configSection($('.recipes_panel_one'), 'Model Info', true);

		let fallbackModels = [];
		let selectedModel = {};
		let optionsList = [];

		models.map((model) => {
			if (model.type === 'qa_prompt') {
				optionsList.push({ value: model.id, label: model.name })
			}
			else if (model.type === 'fallback_llm') {
				fallbackModels.push({ value: model.id, label: model.name })
			}
		});

		console.log('optxy', optionsList)

		let configOne = [
			{
				"title": "Primary Model",
				"key": "modelId",
				"type": "dropdown",
				"placeholder": "Select model",
				"options": optionsList,
				"callback": function (v, o) {
					// console.log('OPTION CALLBACK', v, 'o', o, models )
					selectedModel = models.find(m => m.id == v);
					if( !selectedModel ) return;
					console.log( 'selectedModel', selectedModel )
					if( v != origModel ) {
						origModel = v;
						let copy = ['promptText', 'testText'];
						for (let c of copy) {
							console.log( 'copy', c, selectedModel.llm )
							config[c] = selectedModel.llm[c];
						}
					}
					restConfig();
				},
				"containerClass": "prompt-inline",
			},
			{
				"title": "Fallback model",
				"key": "fallbackModelId",
				"type": "dropdown",
				"placeholder": "Select model",
				"options": fallbackModels,
				"containerClass": "prompt-inline",
			},
		]

		frm.configOptions(typeField, configOne, config);

		function restConfig() {
			let promptField = frm.configSection($('.recipes_panel_one'), 'Model Parameters', true);

            $('.model-parameters-compiled-prompt').remove();
            let compiledPrompt = $('<div>').addClass('model-parameters-compiled-prompt').html('<label>Compiled Prompt</label>')
            promptField.before( compiledPrompt )
            function buildPrompt() {
                clearTimeout( bptid );
                // bptid = setTimeout( function(){
                    console.log( 'buildPrompt', config )
                    let ptext = [];
                    ptext.push( config.promptHead )

					let exn = 1;
					if( config.addPromptExamples ) {
						for( let e of config.promptExamples ) {
							ptext.push( 'Example #' + exn++ );
							for( let p in config.promptInput ) {
								ptext.push( p + ': ' + (e[p] || '') )
							}
							for( let p in config.promptOutput ) {
								ptext.push( p + ': ' + (e[p] || '') )
							}							
						}
					}
					ptext.push( 'Begin!' );
					
					for( let p in config.promptInput ) {
						let pv = config.promptInput[p]
						ptext.push( pv + ': {' + pv + '}' )
					}
					ptext.push( 'Format the answer using following instructions: {FORMAT_INSTRUCTIONS}')
					for( let p in config.promptOutput ) {
						let pv = config.promptOutput[p]
						ptext.push( pv + ':' )
					}


					// let params = [...config.promptParameters];
					// let lastP = params.pop();
					
					// for( let p of params ) {
					// 	ptext.push( p + ': {' + p + '}' )
					// }
					// if( lastP ) ptext.push( lastP + ':' );

                    // ptext.push( 'Question: [Question Here]')
                    // ptext.push( 'Answer: [Answer Here]')
                    // for( let o of config.outputFormat ) {
                    //     ptext.push( o.name + ': [' + (o.description || o.name) + ']')
                    // }
                    // ptext.push( 'Score: [Score Here]')

                    // ptext.push( config.aditionalInstructions)
                    // ptext.push( config.examples)
                    // ptext.push( config.promptEnd)

                    config.promptText = ptext.join('\n\n');
                    $('.model-parameters-compiled-prompt').html('<label>Compiled Prompt</label><p>'+config.promptText.replace(/\n/g, '<br>')+'</p>')
                // }, 300 );
            }

			console.log('selected model', selectedModel)
			console.log('con', config)
			config.llm = selectedModel.llm
            let mout = {
                'name': { type: 'text', placeholder: 'Enter Output Name', fforceWidth: 200, label: 'Name' },
                'description': { type: 'text', placeholder: 'Enter Output Description', fforceWidth: 400, label: 'Description' },
            }
			if( !config.outputFormat && selectedModel.llm && selectedModel.llm.outputFormat ) config.outputFormat = clone(selectedModel.llm.outputFormat);

			// config.promptParameters = ['CONTEXT','USER_QUESTION','CHAT_RESPONSE'];
			config.promptInput = {
				"CONTEXT_VARIABLE": "DOCUMENTS TO USE",
				"QUESTION_VARIABLE": "USER QUESTION",
			}
			config.promptOutput = {
				"ANSWER_VARIABLE": "CHATBOT ANSWER"
			}
			config.promptParameters = ['CONTEXT','QUESTION','ANSWER'];
			
			let configTwo = [
				{
					"key": "recipeName",
					"title": "Prompt Name",
					"label": "prompt name",
					"placeholder": "Enter prompt name",
					"default": selectedModel.name,
					"type": "string"
				},
				{
                    "label": "Summarize document text",
                    "key": "summarization",
                    "placeholder": "Enter prompt head",
					"default": true,
                    "type": "boolean",
					"subFields": [
						{
							"key": "max_words",
							"title": "Max words",
							"placeholder": "Enter max words",
							"default": 50,
							"type": "int"
						},
					]
                },
                {
                    "title": "Prompt Head",
                    "key": "promptHead",
                    "placeholder": "Enter prompt head",
					"default": selectedModel.llm.promptHead,
                    "type": "textarea",
                    "css": { height: 150 },
                    "callback": buildPrompt,
                },
				// {
				// 	"title": "Optional Examples",
				// 	"type": 'title',
				// },

				{
                    "label": "Add prompt examples",
                    "key": "addPromptExamples",
					"default": false,
                    "type": "boolean",
					"callback": function( v ){
						console.log( 'addPromptExamples', v  )
						showExamples();
					},
					"subFields": [
						{
							"id": "opt_examples",
							"type": "div",
							"class": "opt-examples model-opt-examples",
							"html": "prev exmples",
						},
						{
							"id": "opt_examples",
							"type": "div",
							"class": "opt-new-example model-new-example",
							"html": "new examples",
						}
					]
                },
			];
			frm.configOptions(promptField, configTwo, config);

			function showExamples() {
				console.log( 'showExamples' )
				if( !config.promptExamples ) config.promptExamples = [];
				let i = 0;
				$('.opt-examples').html('');
				for( let e of config.promptExamples ) {
					let html = ['<i class="fa fa-close model-example-close" idx="'+i+'"></i>']
					for( let p in config.promptInput ) {
						html.push( '<p><b>'+config.promptInput[p]+':</b> ' + (e[p]||'') + '</p>' );
					}
					for( let p in config.promptOutput ) {
						html.push( '<p><b>'+config.promptOutput[p]+':</b> ' + (e[p]||'') + '</p>' );
					}					
					i++;
					let ediv = $('<div>').addClass('model-example').html( html.join('') );
					$('.opt-examples').append(ediv);
				}
				if( !config.promptExamples.length ) {
					$('.opt-examples').html('<div class="model-example-empty">No examples</div>');
				}
				let nex = {};
				let nconf = [
					{
						"title": "New Example",
						"type": 'title',
					},
				];
				$('.opt-new-example').html('')
				for( let p in config.promptInput ) {
					nconf.push( {
						"key": p,
						"title": config.promptInput[p],
						"placeholder": "Enter example "+config.promptInput[p],
						"default": '',
						"type": "textarea",
						"css": {height:50},
					})
				}
				for( let p in config.promptOutput ) {
					nconf.push( {
						"key": p,
						"title": config.promptOutput[p],
						"placeholder": "Enter example "+config.promptOutput[p],
						"default": '',
						"type": "textarea",
						"css": {height:50},
					})
				}
				nconf.push( {
					"label": 'Add New Example',
					"type": 'button',
					"callback": () => {
						let ck = {...config.promptInput, ...config.promptOutput};
						for( let k in ck ) {
							if( !nex[k] ) return frm.myAlert( 'Missing Field', 'Field "'+ck[k]+'" not filled.')
						}
						config.promptInput = {
							"CONTEXT_VARIABLE": "DOCUMENTS TO USE",
							"QUESTION_VARIABLE": "USER QUESTION",
						}
						config.promptOutput = {
							"ANSWER_VARIABLE": "CHATBOT ANSWER"
						}

						console.log( 'addExample', nex );
						config.promptExamples.push( nex );
						showExamples();
					},
				})
				console.log( 'NCONF', nconf )
				frm.configOptions( $('.opt-new-example'), nconf, nex);
				$('.model-example-close').on('click', function(){
					let idx = $(this).attr('idx')*1
					console.log( 'delete example', idx )
					config.promptExamples.splice( idx, 1 );
					showExamples();
				})
				buildPrompt();
			}
			
			let configThree = [

				{
					"title": "Max Number of similar documents (Top K)",
                    "key": "top_k",
                    "placeholder": "enter top_k",
                    "default": 5,
                    "type": "int",
                },
				{
					"title": "Temperature (0-1)",
					"key": "temperature",
					"placeholder": "enter temperature",
					"default": selectedModel.llm.temperature || 0,
					"type": "float",
				},
				{
					"label": "Use the entire document as Context",
					"key": "use_entire_document",
					"default": false,
					"type": "boolean",
				},
                {
					"title": "Test Text",
                    "key": "testText",
                    "placeholder": "Enter test text",
                    "type": "textarea",
                    "default": selectedModel.llm.testText,
                    "css": { height: 200 },
                },
                {
					"title": "Test Question",
                    "key": "testQuestion",
                    "placeholder": "Enter test question",
                    "default": selectedModel.llm.testQuestion,
                    "type": "text",
				},
				{
					"label": 'Test model',
					"type": 'button',
					"callback": testRecipe,
				}										
			]
			frm.configOptions(promptField, configThree, config);
			setTimeout( showExamples, 1 );
			
			saveConfigBase()
		}
	}

	
	useEffect( () => {
		let run = async () => {
			frm.loading();
			let {data} = await window.post('find_models', { match: {} });
			frm.loadingOut();
			global = window.GlobalVars;
			datasetId = params.datasetId || global.currentDatasetId;
			let res = await window.post('find_datasets', {match:{datasetId: datasetId}});
			window.datasetData = datasetData = res.data.records[0];
			console.log( 'datasets', datasetData )
			let rres = await window.post('find_recipe', {datasetId: datasetId});
			window.recipes = recipes = rres.data.records;
			setModels(data.records);
		};
		run();
	}, [])

	useEffect(() => {

		if( !models ) return;
		
		let s = show;
		console.log('001', recipes, datasetId )
		if( !s ) {
			if (params.recipeType) {
				s = params.recipeType
			}
			else if (datasetData.currentRecipes) {
				s = Object.keys(datasetData.currentRecipes)[0];
			}
			else s = 'classification'
			return setShow(s);
		}
		if( history === null && params.history ) history = params.history;
		setHistory( history )
		if( history ) showHistory();
		drawForm( s );
		if( params.view ) viewPrompts( params.view )
		params = {};
	}, [show, models])


	global = window.GlobalVars;
	if( !global.currentDataset.enableEmbeddingsModel || !global.currentDataset.embeddingModelId ) {
		// alert(1)
		tabs = tabs.filter( v => v != 'Q&A')
		// $('#Q&A').hide();
	}
	return (
		<div fluid="md p-0" className="maincontent">
			<div className="tab_panel d-flex mb-2 py-1">
				{
					tabs.map((tab, index) =>
						<>
							<button key={index} className={`${show === tab ? 'active' : ''} tablinks text-capitalize`} onClick={() => onChange(tab)}>{tab}</button>
						</>
					)}
				<div className='mr-3 mt-2 recipe-buttons hidden'>
					<Button id="savebutton" variant="primary" type="button" className="topbtn ml-2 mb-2 btn btn-primary">Save</Button>
					<Button id="setbutton" variant="primary" type="button" className="topbtn ml-2 mb-2 btn btn-primary">Set Default Prompt</Button>
					<Button id="comparebutton" variant="primary" type="button" className="topbtn ml-2 mb-2 btn btn-primary">Compare Prompts</Button>
					<Button id="historybutton" variant="primary" type="button" className="topbtn ml-2 mb-2 btn btn-primary">Prompt History</Button>
					<Button id="itembutton" variant="primary" type="button" className="topbtn ml-2 mb-2 btn btn-primary">Items</Button>
					<Button id="exportbutton" variant="primary" type="button" className="topbtn ml-2 mb-2 btn btn-primary">Export</Button>
					<Button id="backbutton" variant="primary" type="button" className="topbtn ml-2 mb-2 btn btn-primary">Prompt History</Button>
				</div>
			</div>
			{
				show === 'redaction' && (
					<>
						<div id="redaction" className="tabcontent">
							<div className='recipetab recipes_panel_one'></div>
						</div>
					</>
				)
			}
			{
				show === 'classification' && (
					<>
						<div id="classification" className="tabcontent">
							<div className='recipetab recipes_panel_one'></div>
						</div>
					</>
				)
			}
			{
				show === 'summarization' && (
					<>
						<div id="summarization" className="tabcontent">
							<div className='recipetab recipes_panel_one'></div>
						</div>
					</>
				)
			}
			{
				show === 'Q&A' && (
					<>
						<div id="Q&A" className="tabcontent">
							<div className='recipetab recipes_panel_one'></div>
						</div>
					</>
				)
			}

			<>
				<div className='historytab'>
				</div>
			</>
		</div>
	)
}

export default DatasetRecipes